import { render, staticRenderFns } from "./BistMenu.vue?vue&type=template&id=4c05b489&"
import script from "./BistMenu.vue?vue&type=script&lang=js&"
export * from "./BistMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports